import React, { useEffect } from 'react'
import styles from '../styles.module.css'
import webSocketClient from '../../../webSocketClient'

interface WSMessageResponse {
  type: 'success'
  content: string
  inAttendance: number
}

export function CountAttendance({
  attendeds,
  refetchDriverList
}: {
  attendeds: number

  refetchDriverList: () => Promise<void>
}) {

  useEffect(() => {
    const handleWebSocketResponse = (message: WSMessageResponse) => {
      refetchDriverList()
    }

    webSocketClient.on('countInAttendanceResponse', handleWebSocketResponse)

    return () => {
      webSocketClient.off('countInAttendanceResponse', handleWebSocketResponse)
    }
  }, [refetchDriverList])

  return (
    <div className={styles.attended}>
      <span>Em atendimento</span>
      <p>{attendeds}</p>
    </div>
  )
}
